import axios, { AxiosRequestConfig } from "axios";
import { CashManagementNotificationSettings } from "../models/CashManagement";
import { NotificationSettingsUpdate } from "../models/NotificationSettings";
import { UUID } from "../utils";
import getErrorDetails from "./helpers/getErrorDetails";

export type GetCashManagementNotificationsSettings = (
  customerId: UUID,
  options?: AxiosRequestConfig
) => Promise<CashManagementNotificationSettings>;

export type PostCashManagementNotificationsSettings = (
  customerId: UUID,
  settings: NotificationSettingsUpdate,
  options?: AxiosRequestConfig
) => Promise<CashManagementNotificationSettings>;

export type PutCashManagementNotificationsSettings = (
  customerId: UUID,
  settings: NotificationSettingsUpdate,
  options?: AxiosRequestConfig
) => Promise<CashManagementNotificationSettings>;

export const getCashManagementNotificationsSettings: GetCashManagementNotificationsSettings = async (
  customerId,
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/customers/${customerId}/settlement-notifications/settings`,
    });
    const { data = {} } = response;
    return { ...data, id: customerId };
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return {};
    }
    throw getErrorDetails(error);
  }
};

export const postCashManagementNotificationsSettings: PostCashManagementNotificationsSettings = async (
  customerId,
  settings,
  options
) => {
  try {
    await axios({
      ...options,
      method: "POST",
      url: `/customers/${customerId}/settlement-notifications/settings`,
      data: { ...settings, enabled: true },
    });
    return await getCashManagementNotificationsSettings(customerId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const putCashManagementNotificationsSettings: PutCashManagementNotificationsSettings = async (
  customerId,
  settings,
  options
) => {
  try {
    await axios({
      ...options,
      method: "PUT",
      url: `/customers/${customerId}/settlement-notifications/settings`,
      data: settings,
    });
    return await getCashManagementNotificationsSettings(customerId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};
